import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('PATIENTSIDEBAR/SIDEBAR');

const actions = {
  setInitialState: actionCreator<boolean>('setInitialState'),
  updateInitValue: actionCreator<{
    initValue: boolean;
  }>('updateInitValue'),
};

const thunks = {};

export default { ...actions, ...thunks };
